
    const data = {"name":"app/services/client-portal/arrow-left","data":{"width":"20","height":"20","viewBox":"0 0 20 20","data":"<path pid=\"0\" d=\"M9.058 4.942 4 10l5.058 5.058M15.142 4.942 10.083 10l5.059 5.058\" _stroke=\"#A2A4A5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#A2A4A5"}],"stopColors":[]}}

            export default data
            